var map = {
	"./pcBlack/introduceIcon1nameActive.png": 5905,
	"./pcBlack/introduceIcon2nameActive.png": 2139,
	"./pcBlack/introduceIcon3nameActive.png": 5515,
	"./pcBlack/introduceIcon4nameActive.png": 7385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3921;